import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea, Column } from "rbx";

import {
  SystemCodeSelect,
  BooleanInput,
  CalcTypeSelect,
  GLMainAccountSelect
} from "../inputs";

const ProductForm = ({ inputs, onChange, codeStates }) => (
  <div style={{ width: 800, maxWidth: "100%" }}>
    <Column.Group>
      <Column size={4}>
        <Field kind="group">
          <Control expanded>
            <SystemCodeSelect
              required
              icon="globe"
              label="Product Category"
              lookup={{ Category: "Product", Code: "ProductCatg" }}
              name="ProductCatgRecIdRef"
              value={inputs.ProductCatgRecIdRef}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <SystemCodeSelect
              icon="globe"
              label="Product Group"
              lookup={{ Category: "Product", Code: "ProductGroup" }}
              name="ProductGroupRecIdRef"
              required={
                parseInt(inputs.ProductCatgRecIdRef) === codeStates.sale.RecId
              }
              value={inputs.ProductGroupRecIdRef}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <CalcTypeSelect
              disabled={
                parseInt(inputs.ProductCatgRecIdRef) !== codeStates.fee.RecId
              }
              label="Fee Calculation Type"
              name="CalcTypeRecIdRef"
              value={inputs.CalcTypeRecIdRef}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column size={2}>
        <Field kind="group">
          <Control expanded>
            <Label>Product Code</Label>
            <Input
              required
              autocomplete="new"
              name="ProductCode"
              type="text"
              value={inputs.ProductCode}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Hazmat Code</Label>
            <Input
              autocomplete="new"
              disabled={
                parseInt(inputs.ProductCatgRecIdRef) !== codeStates.sale.RecId
              }
              name="HazmatCode"
              type="text"
              value={inputs.HazmatCode}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field>
          <Control expanded>
            <Label>Price</Label>
            <Input
              autocomplete="new"
              name="Price"
              type="number"
              value={inputs.Price}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column size={6}>
        <Field kind="group">
          <Control expanded>
            <Label>Description</Label>
            <Input
              required
              autocomplete="new"
              name="Description"
              type="text"
              value={inputs.Description}
              onChange={onChange}
            />
          </Control>
          <Control>
            <SystemCodeSelect
              required
              icon="globe"
              label="UOM"
              lookup={{ Category: "Order", Code: "UOM" }}
              name="UOMRecIdRef"
              value={inputs.UOMRecIdRef}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              label="Active"
              name="Active"
              value={inputs.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <GLMainAccountSelect
              label="GL Revenue Account"
              name="RevGLRecIdRef"
              value={inputs.RevGLRecIdRef}
              where={{
                TypeRecIdRef: codeStates.revenue.RecId
              }}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Percent</Label>
            <Input
              autocomplete="new"
              name="Percentage"
              type="number"
              value={inputs.Percentage}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>List Order</Label>
            <Input
              autocomplete="new"
              name="ListOrder"
              type="number"
              value={inputs.ListOrder}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Mandatory Fee</Label>
            <BooleanInput
              label="Mandatory"
              name="Mandatory"
              value={inputs.Mandatory}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
    <Field kind="group">
      <Control expanded>
        <Label>Note</Label>
        <Textarea
          autocomplete="new"
          name="Note"
          rows="2"
          type="text"
          value={inputs.Note}
          onChange={onChange}
        />
      </Control>
    </Field>
  </div>
);

ProductForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  codeStates: PropTypes.object
};

export default ProductForm;
